module.exports = __webpack_public_path__ + "img/codeButton.ea2d3c1a.png";